import { render } from "./CreditCard.vue?vue&type=template&id=479cc8a6"
const script = {}

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__